require.register("blocks/example-custom-block/templates/example-custom-block-template", function(exports, require, module) {
        module.exports = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"example-custom-block\">\n  <h3>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"exampleHeading") || (depth0 != null ? lookupProperty(depth0,"exampleHeading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"exampleHeading","hash":{},"data":data,"loc":{"start":{"line":2,"column":6},"end":{"line":2,"column":24}}}) : helper)))
    + "</h3>\n</div>\n";
},"useData":true});
      })
